import { ClientModel } from "./ClientModel";
import { KeyGeneratorService } from "./KeyGeneratorService";
import { ServerSettingsModel } from "./ServerSettingsModel";
import { NotificationService } from "./NotificationService";

export class ServerSettingsViewModel {
    settingsModel: ServerSettingsModel = null;
    
    private readonly loadUrl: string;
    private readonly saveUrl: string;
    private readonly keyGeneratorService: KeyGeneratorService;
    private readonly notificationService: NotificationService;
    private currentUrl: string;

    constructor(options) {
        this.loadUrl = options.loadUrl;
        this.saveUrl = options.saveUrl;
        this.keyGeneratorService = new KeyGeneratorService(options.newKeyUrl);
        this.notificationService = new NotificationService();
        
        this.settingsModel = new ServerSettingsModel();
    }

    init() {
        ko.applyBindings(this);
        this.load();
    };

    load() {
        $.ajax({
            url: this.loadUrl,
            success: (data: any) => {
                if (data.success) {
                    const settings = data.settings;


                    this.settingsModel.serverUrl(settings.serverUrl);
                    this.settingsModel.apiSecret(settings.apiSecret);
                    this.settingsModel.domainAutoLoginEnabled(settings.domainAutoLoginEnabled);
                    this.settingsModel.applyHostAsOrigin(settings.applyHostAsOrigin);
                    this.settingsModel.hideArmsLoginUI(settings.hideArmsLoginUI);
                    this.settingsModel.supportIISWindowsAuthenticationEnabled(settings.supportIISWindowsAuthenticationEnabled);
                    this.settingsModel.isTwoFactorAuthEnabled(settings.isTwoFactorAuthEnabled);
                    this.settingsModel.twoFactorAuthConfigDelay(settings.twoFactorAuthConfigDelay);
                    this.settingsModel.tokenValidationMode(settings.tokenValidationMode);
                    this.currentUrl = settings.defaultServerUrl;

                    this.settingsModel.clients(settings.clients.map(x => {
                        const vm = new ClientModel();

                        vm.id(x.id);
                        vm.url(x.url);
                        vm.name(x.name);
                        vm.secret(x.secret);
                        vm.installed(x.installed);

                        return vm;
                    }));
                }
            }
        })
    }

    refresh() {
        this.load();
    }

    applyCurrentUrl() {
        this.settingsModel.serverUrl(this.currentUrl);
    }

    private async generateKey() {
        const keyResult = await this.keyGeneratorService.getNewKey();
        if (keyResult.success) {
            return keyResult.key;
        }
    }

    async generateKeyForServer() {
        const key = await this.generateKey();
        this.settingsModel.apiSecret(key);
    }

    async generateKeyForClient(client: ClientModel) {
        const key = await this.generateKey();
        client.secret(key);
    }

    onSubmit() {
        if (!this.validate()){
            this.notificationService.showError("Settings are not valid");
            return;
        }
        
        $.ajax({
            url: this.saveUrl,
            type: "POST",
            data: ko.toJS(this.settingsModel),
            success: data => {
                if (data.success) {
                    this.notificationService.showInfo(["Settings Saved", "Don't forget to restart IIS to apply updated settings"]);
                } else {
                    this.notificationService.showError(data.message);
                } 
            }
        });
    }

    validate() {
        const errors = ko.validation.group(this, {
            deep: true,
            observable: true,
        });
        errors.showAllMessages();
        return errors().length === 0;
    }
}

